export default __webpack_public_path__ + "static/media/CRM-5.554394a0.png";